import { useServices } from 'core/services';
import { BaseHttpError } from 'core/services/api/errors';
import { FeedResponse } from 'core/services/api/response-types';
import { FeedRecord } from 'core/types';
import { getPageParams } from 'core/utils/pagination';
import { communityKeys } from 'core/utils/query-key-factory';
import { useCallback } from 'react';
import {
	useInfiniteQuery,
	InfiniteData,
	QueryFunctionContext,
} from '@tanstack/react-query';

export const useGetCommunityFeed = (
	id: string,
	options: { enable: boolean } = { enable: true }
) => {
	const { api, authentication } = useServices();

	const isLoggedIn = authentication.isAuthenticated();

	return useInfiniteQuery<
		FeedResponse,
		BaseHttpError,
		InfiniteData<FeedRecord[]>
	>({
		queryKey: communityKeys.feed(id),
		queryFn: useCallback(
			({ pageParam, signal }: QueryFunctionContext) => {
				return api.getCommunityFeed(id, {
					pagination: pageParam as any,
					signal,
				});
			},
			[id]
		),
		initialPageParam: undefined,
		enabled: !!id && isLoggedIn && options.enable,
		select: response => {
			return {
				pages: response.pages.map(page => page.data),
				pageParams: response.pageParams,
			};
		},
		getPreviousPageParam: firstPage =>
			getPageParams(firstPage.pagination).previousParam,
		getNextPageParam: lastPage =>
			getPageParams(lastPage.pagination).nextParam,
		refetchOnMount: true,
	});
};
